import { AlterResponse } from "../../models/AlterView";
import { View } from "../View";

export default class Q4_3 extends View {
    render() {
        return (
            <div className="Q4_3">
                <h2>Jouons avec les sujets !<br/> Qui voulez-vous mettre en pause ?</h2>
                <hr />
                <div className="btn-group btn-group-3">
                    <button onClick={ () => this.props.onFinish(AlterResponse.SUBJECT_1) }>Le sujet féminin</button>
                    <button onClick={ () => this.props.onFinish(AlterResponse.SUBJECT_2) }>Le sujet masculin</button>
                    <button onClick={ () => this.props.onFinish(AlterResponse.BOTH) }>Les deux</button>
                </div>
            </div>
        );
    }
}
